import {
  type ConnectionErrorForm,
  failConnectionAddOperation,
  startConnectionAddOperation,
  succeedConnectionAddOperation,
  useConnectionApiErrorHandler,
} from '@mint-lib/connections-ui';
import type { BasicConnectResult } from '@mint-lib/omni-integration';
import { OmniAuthBasic } from '@mint-sdk/api-omni';

/**
 * Ported from `packages/connections/src/components/_organisms/AddConnectionBasicForm/useCreateBasicConnectionHandlers.ts`'s
 * zemanta branch — the token/credentials (non-OAuth) connect flow. The
 * reconnect side is the shared `@mint-lib/omni-integration`'s
 * `useBasicReconnect`.
 */
export interface ZemantaConnectResult extends BasicConnectResult {
  connect: (values: {
    name: string;
    username: string;
    password: string;
  }) => void;
}

/** Duplicate names go to `form`'s `name` field; other failures show an "Invalid Credentials" snackbar. */
export function useZemantaConnect(
  urn: string,
  form?: ConnectionErrorForm,
): ZemantaConnectResult {
  const { mutate, data, isPending } = OmniAuthBasic.omniAuthBasic();
  const handleApiError = useConnectionApiErrorHandler({
    form,
    flow: 'credentials',
  });

  return {
    connect: (values) => {
      startConnectionAddOperation({
        platform: urn,
        flow: 'basic',
        registry: true,
      });
      mutate(
        {
          data: {
            connectionName: values.name,
            platform: urn,
            credentials: {
              username: values.username,
              password: values.password,
            },
          },
        },
        {
          onSuccess: succeedConnectionAddOperation,
          onError: (error) => {
            failConnectionAddOperation('error');
            handleApiError(error);
          },
        },
      );
    },
    connectionId: data?.data?.items[0]?.connectionId,
    isPending,
  };
}
